var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":"/img/logo1.png","tag":"ArtistHub Logo"}})])
}]

export { render, staticRenderFns }